import { render, staticRenderFns } from "./VaultModal.vue?vue&type=template&id=1d40c2a5&scoped=true&"
import script from "./VaultModal.vue?vue&type=script&lang=ts&"
export * from "./VaultModal.vue?vue&type=script&lang=ts&"
import style0 from "./VaultModal.vue?vue&type=style&index=0&id=1d40c2a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40c2a5",
  null
  
)

export default component.exports